import { render } from "./AdminCronPage.vue?vue&type=template&id=58df7624"
import script from "./AdminCronPage.vue?vue&type=script&lang=js"
export * from "./AdminCronPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__